var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowMobileLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95 11.9c-.257 0-.513-.1-.708-.294l-4.95-4.95v-.002H.29c0-.002-.002-.003-.002-.002 0 0 0-.002-.002-.002 0-.002-.003-.003-.003-.003-.002 0-.002-.003-.002-.002v-.002c-.002 0-.003-.002-.003-.003l-.003-.002s0-.002-.002-.003L.27 6.633a.964.964 0 01-.195-.303v-.002A.977.977 0 010 5.968V5.93a1.003 1.003 0 01.27-.666s0-.002.002-.003c0 0 .002 0 .002-.002.002 0 .003-.002.003-.002l.002-.002v-.002s.002 0 .003-.002c0 0 .003.006.002-.002l.003-.003s.008.002.002-.002l.003-.003 4.95-4.95a1 1 0 111.413 1.415L3.414 4.95H14a1 1 0 110 2H3.414l3.242 3.242a1 1 0 01-.707 1.707",
    fill: "#384a5f",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMobileLeft);
export default __webpack_public_path__ + "static/media/arrow-mobile-left.e2cab5ead1aaa99164587d8c2bc9f738.svg";
export { ForwardRef as ReactComponent };